<template>
  <section class="menu-banner">
    <base-image
      class="menu-banner__image"
      :mobile-url="fields?.heroMobile?.value?.src"
      :tablet-url="fields?.heroTablet?.value?.src"
      :desktop-url="fields?.heroDesktop?.value?.src"
      :desktop-alt="fields?.heroDesktop?.value?.alt"
      :tablet-alt="fields?.heroTablet?.value?.alt"
      :mobile-alt="fields?.heroMobile?.value?.alt"
      :full-width="true"
    />
    <div class="menu-banner__content-wrapper">
      <div class="container">
        <div class="menu-banner__content">
          <sc-text tag="h1" class="menu-banner__title font-l" :field="fields?.headerBannerTitle" />
          <div v-if="rawVenueId && locationKey" class="menu-banner__reviews-section">
            <button
              class="menu-banner__reviews-button link inverted-underline"
              @click="onVenueInfoClick"
            >
              <i class="icon icon-Info" aria-hidden="true" />
              {{ t('iorder-venue-food-hygiene-awards') }}
            </button>
          </div>
          <sc-text
            tag="p"
            class="menu-banner__description"
            :field="fields?.headerBannerDescription"
          />
          <base-button
            v-if="fields?.headerBannerCta?.value"
            :link="fields.headerBannerCta.value"
            type="link"
            variant="secondary"
            class="menu-banner__cta"
            @click="registerDLAction(fields.headerBannerCta.value.text)"
          />
        </div>
      </div>
    </div>
  </section>
  <venue-info-modal
    ref="modalRef"
    :location-id="locationKey"
    :venue-id="rawVenueId"
    show-venue-info-first
  />
</template>

<script setup>
import { ref, inject } from 'vue';
import { Text as ScText } from '@sitecore-jss/sitecore-jss-vue';
import { useI18n } from 'vue-i18n';
import BaseImage from '../../2_elements/BaseImage/BaseImage.vue';
import BaseButton from '../../2_elements/BaseButton/BaseButton.vue';
import VenueInfoModal from '../../VenueInfoModal/VenueInfoModal.vue';
import { useButtonsAndLinksTracking } from '../../../data-layer/hooks/useButtonsAndLinksTracking.js';

const jssStore = inject('jssStore');
const sitecoreContext = jssStore?.sitecoreContext() || {};
const rawVenueId = sitecoreContext.rawVenueId;
const locationKey = sitecoreContext.locationKey;

const { t } = useI18n();

const { trackButtonState } = useButtonsAndLinksTracking({ componentName: 'iorder_menu_header' });

defineProps({
  fields: {
    type: Object,
    default: () => ({}),
  },
  rendering: {
    type: Object,
  },
  params: {
    type: Object,
  },
});

const modalRef = ref(null);

const onVenueInfoClick = () => {
  if (modalRef.value) {
    modalRef.value.openModal();
    registerDLAction(t('iorder-venue-food-hygiene-awards'));
  }
};

const registerDLAction = (linkText) => {
  trackButtonState(linkText);
};
</script>
<style lang="scss">
@import './scss/MenuBanner.scss';
</style>
